import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import es from 'vuetify/es5/locale/es'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#1a427f',
        secondary: '#009a4e',
      }
    }
  },
  lang: {
    locales: { es },
    current: 'es',
  },
})
